// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    /*text-align: center;*/
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

html, body, #root, .App {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
}

#map {
    /*width: 100vw;*/
    /*height: 100vh;*/
    /*position: relative;*/
    /*overflow: hidden;*/
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
}

.popup-preview-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-family: sans-serif;
    max-height: 300px;
    overflow-y: auto;
    padding: 0.5rem;
    box-sizing: border-box;
}

.popup-preview-card {
    background: white;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    padding: 0.5rem 0.75rem;
}

.popup-preview-details {
    display: flex;
    flex-direction: column;
}

.popup-preview-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.25rem;
}

.popup-preview-icon {
    width: 10px;
    height: 10px;
    background-color: #007cbf;
    border-radius: 50%;
}

.popup-preview-name {
    font-weight: bold;
    font-size: 14px;
}

.popup-preview-info {
    text-align: left;
    margin-left: auto;
    margin-right: auto;
}

.popup-preview-info div {
    font-size: 13px;
    margin-bottom: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".App {\n    /*text-align: center;*/\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\nhtml, body, #root, .App {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    width: 100%;\n}\n\n#map {\n    /*width: 100vw;*/\n    /*height: 100vh;*/\n    /*position: relative;*/\n    /*overflow: hidden;*/\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 100%;\n}\n\n.popup-preview-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    font-family: sans-serif;\n    max-height: 300px;\n    overflow-y: auto;\n    padding: 0.5rem;\n    box-sizing: border-box;\n}\n\n.popup-preview-card {\n    background: white;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    padding: 0.5rem 0.75rem;\n}\n\n.popup-preview-details {\n    display: flex;\n    flex-direction: column;\n}\n\n.popup-preview-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.25rem;\n}\n\n.popup-preview-icon {\n    width: 10px;\n    height: 10px;\n    background-color: #007cbf;\n    border-radius: 50%;\n}\n\n.popup-preview-name {\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.popup-preview-info {\n    text-align: left;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.popup-preview-info div {\n    font-size: 13px;\n    margin-bottom: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
